

















































































































import moment from 'moment';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import AgreementLimitHistoryEntry from '@/domain/agreement-limits/entity/agreement-limit-history-entry.entity';
import AgreementLimitService from '@/domain/agreement-limits/service/agreement-limit.service';
import AgreementType from '@/domain/agreement-limits/entity/agreement-type.enum';
import CardTitle from '@/shared/card/card-title.component.vue';
import Loading from '@/shared/loading/loading.component.vue';

const AGREEMENT_TYPE_LABELS: Record<string, string> = {
  [AgreementType.INITIAL_SCORE]: 'Acordos Iniciais',
  [AgreementType.COUNTING]: 'Contagens',
  [AgreementType.UNSCHEDULED_SCORE]: 'Acordos Avulsos',
};

@Component({
  components: {
    CardTitle,
    Loading,
  },
})
export default class AgreementLimitHistoryDrawer extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) showDrawer!: boolean;

  historyEntries: AgreementLimitHistoryEntry[] = [];

  loading: boolean = false;

  loadingMore: boolean = false;

  page: number = 0;

  hasMore: boolean = true;

  static readonly PAGE_SIZE = 10;

  @Watch('showDrawer')
  onShowDrawerChange(value: boolean): void {
    if (value) this.getHistory();
  }

  onDrawerInput(value: boolean): void {
    if (!value) this.$emit('closeDrawer', false);
  }

  getHistory(): Promise<void> {
    this.loading = true;
    this.page = 0;
    this.hasMore = true;
    this.historyEntries = [];
    return this.fetchPage()
      .finally(() => {
        this.loading = false;
      });
  }

  onScroll(event: UIEvent): void {
    const target = event.target as HTMLElement;
    const reachedBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 100;
    if (reachedBottom && !this.loading && !this.loadingMore && this.hasMore) {
      this.loadingMore = true;
      this.fetchPage()
        .finally(() => {
          this.loadingMore = false;
        });
    }
  }

  fetchPage(): Promise<void> {
    return AgreementLimitService.getHistory(this.page, AgreementLimitHistoryDrawer.PAGE_SIZE)
      .then(({ data }: any) => {
        const newEntries = AgreementLimitHistoryEntry.ofList(data.content);
        this.historyEntries = this.historyEntries.concat(newEntries);
        this.hasMore = !data.last;
        this.page += 1;
      })
      .catch(VbSnackbarService.handleHttpError);
  }

  formatChangedAt(changedAt: string): string {
    return changedAt ? moment(changedAt).format('DD/MM/YYYY HH:mm') : '';
  }

  agreementTypeLabel(agreementType: string): string {
    return AGREEMENT_TYPE_LABELS[agreementType] || agreementType;
  }

  cargoSectionLabel(leader: boolean): string {
    return leader ? 'Cargo de Liderança' : 'Colaboradores';
  }
}
